import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var WAIT_TO_TEST = 10000;
var NOTICE_ID = "notice-corrupt-rest-api";
/**
 * Register a new endpoint which needs to resolve to a valid JSON result. In this way we
 * can detect a corrupt REST API namespace e. g. it is blocked through a security plugin.
 */

function handleCorrupRestApi(resolve) {
  var forceRerequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // Initially set
  window.detectCorruptRestApiFailed = window.detectCorruptRestApiFailed || 0;
  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var notice, _i, _Object$keys, namespace, li;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            notice = document.getElementById(NOTICE_ID); // Only in backend and when a corrupt REST API detected

            if (!(notice && (window.detectCorruptRestApiFailed > 0 || forceRerequest))) {
              _context.next = 19;
              break;
            }

            _i = 0, _Object$keys = Object.keys(resolve);

          case 3:
            if (!(_i < _Object$keys.length)) {
              _context.next = 19;
              break;
            }

            namespace = _Object$keys[_i];
            _context.prev = 5;
            _context.next = 8;
            return resolve[namespace]();

          case 8:
            _context.next = 16;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](5);
            notice.style.display = "block";
            li = document.createElement("li");
            li.innerHTML = "- <code>".concat(namespace, "</code>");
            notice.childNodes[1].appendChild(li);

          case 16:
            _i++;
            _context.next = 3;
            break;

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 10]]);
  })), WAIT_TO_TEST);
}

export { handleCorrupRestApi };